<script lang="ts">
	//Helpers
	import { getTimeAgo } from '../../../helpers/date_helper';
	//Stores
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { AdvancedCard, Icon } from '@Shelly/shelly-design-system';
	//Components
	import NavigateToIp from '../NetworkComponents/NavigateToIP.svelte';
	//Types
	import type { Device } from '../../../types/Device';

	export let device: Device,
		client: { mport: number; ip: string; since: number },
		image: string,
		title: string;

	$: statusStore = getDeviceStatus(device.id);
	$: ip = $statusStore?.eth?.ip || $statusStore?.wifi?.sta_ip;
</script>

<AdvancedCard class="mb-s" {title} avatar={{ image }}>
	<div slot="main">
		<NavigateToIp ip={`${ip}:${client.mport}`}>
			<Icon icon="fas fa-link" size="xs" />
		</NavigateToIp>
		<NavigateToIp ip={client.ip}>
			<Icon icon="fas fa-link" size="xs" />
		</NavigateToIp>
		<Icon icon="fas fa-clock" size="xs" style="top: -1px;position: relative;" />
		<span class="tiny-styles text-nowrap">
			{getTimeAgo(client.since * 1000)}
		</span>
	</div>
</AdvancedCard>
